import { IdentityAdapters } from '../adapters';
import { IdentitiesApi } from '../clients';

/**
 * A–Z by name, which is the order the ticket asks for and one the endpoint
 * does not offer. Nameless identities go last, ordered by email, so they do not
 * crowd the top of the list.
 */
const compareByName = (a, b) => {
  if (a.name && b.name) return a.name.localeCompare(b.name);
  if (a.name) return -1;
  if (b.name) return 1;

  return (a.email ?? '').localeCompare(b.email ?? '');
};

/**
 * A location's identities, A–Z by name.
 *
 * @param {string} officeId - The office's monolith id
 * @returns {Promise<import('../types/Identity.api').IIdentityApiModel[]>}
 */
export const getLocationIdentities = async (officeId) => {
  const response = await IdentitiesApi.getLocationIdentities(officeId);

  return [...IdentityAdapters.toIdentities(response)].sort(compareByName);
};
